// extracted by mini-css-extract-plugin
export default {"root":"_102Jp","box":"_3-Arn","message":"_2faUG","button":"xE7Cm"};